/**
 * Created by mgoria on 5/27/2015
 */

'use strict';

var _Asset = require('./Asset');

module.exports = _Asset.Asset;


//////////////////
// WEBPACK FOOTER
// ../~/deep-asset/lib.compiled/bootstrap.js
// module id = 345
// module chunks = 0